<div [hidden]="!getSrc()">
  <iframe [src]="getSrc() | safeUrl" [style.height]=getHeight()></iframe>
</div>
<div class="noSrcTxt" [hidden]="getSrc()">
  <div>{{getNoSrcMessage()}}</div>
</div>